import { useLocation, useNavigate } from 'react-router-dom'//npm install react-router-dom
import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import axios from 'axios'
import { useEffect, useState, useRef } from "react"
import DivBottom from '../userNotAuth/components/divBottom'
import AuthProvider from './authProvider'

function ReimpostaEmail() {
    const navigate = useNavigate()
    const location = useLocation()
    const [emailNuova, setEmailNuova] = useState({
        emailNuova: null,
        emailOld: localStorage.getItem('email'),
        rndCode: null
    })
    const [formData, setFormData] = useState()
    const [msg, setMsg] = useState({ errSubmit: null })
    const bannerRegSuccess = useRef()
    const bannerForm = useRef()

    const divFlex = {
        backgroundColor: ' #f1f1f1',
        width: '3rem',
        margin: '5px',
        textAlign: 'center',
        lineHeight: '4rem',
        fontSize: 'x-large',
    }
    function handleClick(e) {
        setMsg({ errSubmit: null })
        const name = e.target.name
        document.getElementById(name).value = ''
        setFormData({ ...formData, [name]: '' })
    }
    function handleChange(e) {
        const { name, value, type, checked } = e.target
        const inputValue = type === "checkbox" ? checked : value
        if (isNaN(inputValue) || inputValue === '') { //inputValue not a number or empty
            document.getElementById(name).value = ''
            return
        }
        setFormData({ ...formData, [name]: inputValue })
        name === 'rndCode1' && document.getElementById('rndCode2').focus()
        name === 'rndCode2' && document.getElementById('rndCode3').focus()
        name === 'rndCode3' && document.getElementById('rndCode4').focus()
        name === 'rndCode4' && document.getElementById('rndCode5').focus()
    }
    function handleSubmit(e) {
        e.preventDefault()
        const valuesObjectToString = Object.values(formData).toString()
        const stringSenzaVirgole = valuesObjectToString.replace(/,/g, "")
        if (emailNuova.rndCode !== parseInt(stringSenzaVirgole)) {
            setMsg({ ...msg, errSubmit: `Codice errato, controlla l'email e riprova` })
        } else {//accettazione codice
            axios.post('/modificaEmail', emailNuova).then(res => {
                if (res.data === 'Success') {
                    bannerRegSuccess.current.style.left = '12%'
                    bannerForm.current.style.opacity = '0'
                    localStorage.setItem('email', emailNuova.emailNuova)
                }
            })
        }
    }
    useEffect(() => {
        if (emailNuova.rndCode !== null) {
            document.getElementById('rndCode1').focus()
        }
    }, [emailNuova.rndCode])

    useEffect(() => {
        if (localStorage.getItem('previousPage') !== '/user') {
            navigate('/', { replace: true })
        } else {
            setEmailNuova({
                ...emailNuova,
                emailNuova: location.state.emailNuova,
                rndCode: location.state.rndCode
            })
            localStorage.removeItem('previousPage')
        }
    }, [])

    return (<>
        <NavbarNotAuth />
        <div className='container'>
            <h2 style={{ marginTop: '6rem' }}><b>Modifica email</b></h2><hr />
            {emailNuova.rndCode &&
                <div style={{ marginBottom: '8rem' }} ref={bannerForm}>
                    <h5>Inserisci il codice numerico che hai ricevuto nell'email entro 5 minuti.</h5>
                    <form onSubmit={handleSubmit}>
                        <div style={{
                            display: 'flex',
                            flexWrap: 'nowrap',
                            width: 'fit-content'
                        }}>
                            <input style={divFlex} id="rndCode1"
                                type='text' maxLength={1}
                                name='rndCode1'
                                required
                                onChange={handleChange}
                                onClick={handleClick} />
                            <input style={divFlex} id="rndCode2"
                                type='text' maxLength={1}
                                name='rndCode2'
                                required
                                onChange={handleChange}
                                onClick={handleClick} />
                            <input style={divFlex} id="rndCode3"
                                type='text' maxLength={1}
                                name='rndCode3'
                                required
                                onChange={handleChange}
                                onClick={handleClick} />
                            <input style={divFlex} id="rndCode4"
                                type='text' maxLength={1}
                                name='rndCode4'
                                required
                                onChange={handleChange}
                                onClick={handleClick} />
                            <input style={divFlex} id="rndCode5"
                                type='text' maxLength={1}
                                name='rndCode5'
                                required
                                onChange={handleChange}
                                onClick={handleClick} />
                        </div>
                        {msg.errSubmit && <p style={{ color: 'red' }}><i>{msg.errSubmit}</i></p>}
                        <div className='mt-4'>
                            <button className='btn btn-secondary' type='submit'>INVIA</button>
                        </div>
                    </form>
                </div>
            }
            {/* -------------- BANNER REGISTRAZIONE NUOVA EMAIL -------------- */}
            <div style={{
                left: '-100rem', transition: '.3s', position: 'absolute', top: '7rem',
                width: '100%', padding: '1rem'
            }} ref={bannerRegSuccess}>
                <br /><br />
                <h1 className='mt-5' style={{
                    margin: '0 auto',
                    backgroundColor: 'white',
                    borderRadius: '20px',
                    border: '1px solid black',
                    padding: '10px',
                    width: 'fit-content'
                }}>ZONA EVENTI
                </h1><br />
                <h3 className='mt-4'>Email modificata</h3>
                <h5 className='mt-3'>
                    La tua email è stata modificata con successo.<br />
                    Per i prossimi accessi a www.zona-eventi.it dovrai usare la nuova email. <i>{emailNuova.email}</i>
                </h5>
            </div>
        </div>
        <DivBottom />
    </>)
}
export default ReimpostaEmail